import { useRoutes } from "react-router";
import { routes } from "./app/RouteObject";

function App() {
  let routeObjects = useRoutes(routes);
  return <>{routeObjects}</>;
}

export default App;
